export const REWARD_RULES = {
  editor: "reward-rules-editor",
  editButton: "reward-rules-edit-button",
  effectiveDateInput: "rule-effective-date",
  saveButton: "reward-rules-save-button",
  customerResidentialFeeInput: "rule-customer-residential-fee-input",
  ambassadorStep1FeeInput: "rule-ambassador-step1-fee-input",
  ambassadorStep1MaxInput: "rule-ambassador-step1-max-input",
  ambassadorStep2FeeInput: "rule-ambassador-step2-fee-input",
  ambassadorStep2MaxInput: "rule-ambassador-step2-max-input",
  ambassadorStep3FeeInput: "rule-ambassador-step3-fee-input",
  commercialBand1MaxInput: "rule-commercial-band1-max-input",
  commercialBand1FeeInput: "rule-commercial-band1-fee-input",
  commercialBand2MaxInput: "rule-commercial-band2-max-input",
  commercialBand2FeeInput: "rule-commercial-band2-fee-input",
  commercialBand3MaxInput: "rule-commercial-band3-max-input",
  commercialBand3FeeInput: "rule-commercial-band3-fee-input",
  commercialBand4AmbassadorFeeInput: "rule-commercial-band4-ambassador-fee-input",
  dealDeskThresholdInput: "rule-deal-desk-threshold-input",
};

export const ADMIN_REWARDS = {
  capacityDialog: "admin-reward-capacity-dialog",
  capacityInput: "admin-reward-capacity-input",
  capacitySegmentSelect: "admin-reward-capacity-segment-select",
  capacitySaveButton: "admin-reward-capacity-save-button",
};

export const MEMBER_RULES = {
  dialog: "reward-rules-dialog",
  trigger: "reward-rules-trigger",
};
